import { render, staticRenderFns } from "./CalendarStudent.vue?vue&type=template&id=13b40d58&scoped=true"
import script from "./CalendarStudent.vue?vue&type=script&lang=js"
export * from "./CalendarStudent.vue?vue&type=script&lang=js"
import style0 from "./CalendarStudent.vue?vue&type=style&index=0&id=13b40d58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b40d58",
  null
  
)

export default component.exports